var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.08,
    height: 55.318,
    viewBox: "0 0 61.08 55.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M1184.316,606.958h-34.976a10.989,10.989,0,0,0-10.956,10.956v21.595a10.99,10.99,0,0,0,10.145,10.923v8.5a1.315,1.315,0,0,0,2.234.94l9.608-9.4h26.136a10.989,10.989,0,0,0,10.956-10.956v-19.4A13.186,13.186,0,0,0,1184.316,606.958Z",
    transform: "translate(-1138.383 -606.958)",
    fill: "none",
    stroke: "#0029fc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 33.569,
    transform: "translate(12.681 17.204)",
    fill: "none",
    stroke: "#0029fc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    x2: 21.558,
    transform: "translate(12.681 26.752)",
    fill: "none",
    stroke: "#0029fc",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextChat);
export default __webpack_public_path__ + "static/media/text-chat.3d91d715fc171b63cba2e08b6b1c645b.svg";
export { ForwardRef as ReactComponent };